import { Input } from '@material-ui/core';
import * as React from 'react';
import { compose, withHandlers } from 'recompose';
import { Text } from '../../';
import { withBaseProps } from '../../Utils';
import { SelectWrapped } from './AutocompleteMultiSelectComponents/SelectWrapped';
import { styles } from './AutocompleteMultiSelectStyles';
import { filterBySearchText } from './AutocompleteMultiSelectUtils';
const AutocompleteMultiSelect = (props) => {
    const { cacheUniq, changeHandler, classes, countTranslationKey, disabled, dropdownPlacement, dropdownPosition, iconConfig, input, isAsync, isClearable, isCreatable, isMulti, items, label, loadOptionsHandler, mapValuesToSelectOptionsHandler, meta, placeholder, selectClasses = {}, shouldLoadMoreHandler, t, theme, testId = 'AutocompleteMultiSelect', } = props;
    const inputProps = {
        cacheUniq,
        classes,
        countTranslationKey,
        disabled,
        iconConfig,
        isAsync,
        isClearable,
        isCreatable,
        isMulti,
        items,
        loadOptionsHandler,
        mapValuesToSelectOptionsHandler,
        maxMenuHeight: 250,
        menuPlacement: dropdownPlacement || 'bottom',
        menuPosition: dropdownPosition || 'fixed',
        options: items,
        placeholder,
        selectClasses,
        shouldLoadMoreHandler,
        t,
        theme,
        testId,
    };
    const labelEl = (React.createElement(Text, { block: true, lineHeight: theme.font.lineHeight.medium, size: theme.font.size.mediumSmall }, label));
    const hasError = meta && !!meta.error && meta.dirty;
    const errorEl = hasError && (React.createElement(Text, { block: true, color: theme.color.error.main, lineHeight: theme.font.lineHeight.mediumBig, size: theme.font.size.mediumSmall }, meta ? meta.error : null));
    return (React.createElement(React.Fragment, null,
        label && labelEl,
        React.createElement(Input, { "data-testid": testId, classes: selectClasses, className: disabled ? classes.disabledInput : classes.field, error: hasError, fullWidth: true, inputComponent: SelectWrapped, inputProps: inputProps, onChange: changeHandler, value: input ? input.value : null }),
        errorEl));
};
export default compose(withBaseProps({ styles }), withHandlers({
    changeHandler: (props) => (items) => {
        const onChange = props.onChange || props.input ? props.input.onChange : () => null;
        const getValue = (item) => (props.useRawValue ? item : item.value);
        if (Array.isArray(items)) {
            if (props.selectLimit && items.length > props.selectLimit) {
                return;
            }
            onChange(items.map((item) => getValue(item)));
        }
        else {
            onChange(getValue(items));
        }
    },
    mapValuesToSelectOptionsHandler: (props) => (value) => {
        const { items = [] } = props;
        let selectedItem;
        if (typeof value === 'string') {
            selectedItem = items.find((item) => item.value === value);
        }
        return Array.isArray(value)
            ? [...value].map((v) => {
                return typeof v === 'string'
                    ? {
                        label: v,
                        value: v,
                    }
                    : v;
            })
            : selectedItem || value;
    },
    shouldLoadMoreHandler: () => (scrollHeight, clientHeight, scrollTop) => {
        const bottomBorder = (scrollHeight - clientHeight) / 2;
        return bottomBorder < scrollTop;
    },
    loadOptionsHandler: ({ getList, isAsync, items = [], variables = {} }) => async (searchText, prevOptions) => {
        const first = 20;
        if (!isAsync) {
            const filteredOptions = filterBySearchText(items, 'label', searchText);
            const hasMore = filteredOptions.length > prevOptions.length + first;
            const slicedOptions = filteredOptions.slice(prevOptions.length, prevOptions.length + first);
            return {
                cursor: null,
                hasMore,
                options: slicedOptions,
            };
        }
        const requestParams = {
            currentCount: prevOptions.length,
            first: first,
            search: searchText,
        };
        if (prevOptions.length) {
            requestParams.after = prevOptions[prevOptions.length - 1].cursor || '';
        }
        return getList
            ? getList(requestParams, variables)
            : {
                cursor: null,
                hasMore: false,
                options: [],
            };
    },
}))(AutocompleteMultiSelect);
//# sourceMappingURL=AutocompleteMultiSelect.js.map